module.exports = __webpack_public_path__ + "img/step1.a3dc0943.png";